/* eslint-disable */

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Search } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useStore from "../../store/store";
import useAsync from "../../hooks/useAsync";
import StoreServices from "../../services/StoreServices";
import useLogout from "../../hooks/useLogout";

const Header = () => {
  const route = all_routes;
  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [flagImage, setFlagImage] = useState("assets/img/flags/in.png");
  const { t, i18n } = useTranslation();
  const user = useStore((state) => state.user);
  const { handleLogout } = useLogout();

  const {
    data: stores,
    loading,
    error,
  } = useAsync(() => {
    if (!user) return null;

    const fetchStoreData = async () => {
      if (user.role === "franchise_owner" && user.franchiseId) {
        try {
          return StoreServices.getFranchiseStores(user.franchiseId);
        } catch (error) {
          console.error("Error fetching franchise stores:", error);
          return null;
        }
      }

      // For store managers, they'll only see their own store
      if (user.role === "store_manager") {
        try {
          const response = await StoreServices.getStoreByUserId(user.id);
          // Set selected store immediately for store managers
          if (response?.success && response?.data) {
            setSelectedStore(response.data);
          }
          return { data: [response.data] }; // Wrap single store in array to match other responses
        } catch (error) {
          console.error("Error fetching store:", error);
          return null;
        }
      }
      // For super admins or brand owners, they can see all stores
      if (user.role === "super_admin") {
        try {
          const response = await StoreServices.getAllStores();
          if (response?.success && response?.data) {
            setSelectedStore(response.data[0]); // Set the first store as selected
          }
          return { data: [...response.data] }; // Return all stores
        } catch (error) {
          console.error("Error fetching all stores:", error);
          return null;
        }
      }
    };

    return fetchStoreData();
  });

  const selectedStore = useStore((state) => state.selectedStore);
  const setSelectedStore = useStore((state) => state.setSelectedStore);

  const handleStoreSelect = (store) => {
    setSelectedStore(store);
    // window.location.reload();
  };

  const changeLanguage = (lng) => {
    // Debugging statement
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? "assets/img/flags/us-flag.svg"
        : lng === "fr"
        ? "assets/img/flags/fr.png"
        : lng === "es"
        ? "assets/img/flags/es.png"
        : "assets/img/flags/de.png"
    );
  };
  const isElementVisible = (element) => {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
  };

  useEffect(() => {
    // Set default selected store when stores are loaded
    if (stores?.data?.length && !selectedStore) {
      // For store managers, they'll only see their store
      if (user?.role === "store_manager") {
        setSelectedStore(stores.data[0]);
      }
      // For franchise owners, select their first store
      else if (user?.role === "franchise_owner") {
        setSelectedStore(stores.data[0]);
      }
      // For super admins or brand owners, select the first store
      else {
        setSelectedStore(stores.data[0]);
      }
    }
  }, [stores, selectedStore, user]);

  useEffect(() => {
    const handleMouseover = (e) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []);
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(
        document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return "";
  }

  const toggleFullscreen = (elem) => {
    elem = elem || document.documentElement;
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };
  const { expandMenus } = useSelector(
    (state) => state.themeSetting.expandMenus
  );
  const dataLayout = useSelector((state) => state.themeSetting.dataLayout);

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const renderUserAvatar = () => {
    return (
      <ImageWithBasePath
        src="assets/img/profiles/default-avatar.png"
        alt="Img"
        className="img-fluid"
      />
    );
  };

  return (
    <>
      <div className="header">
        {/* Logo */}
        <div className="main-header">
          <div
            className={`header-left
             ${toggle ? "" : "active"}
             ${
               expandMenus || dataLayout === "layout-hovered"
                 ? "expand-menu"
                 : ""
             }
             `}
            onMouseLeave={expandMenu}
            onMouseOver={expandMenuOpen}
          >
            <Link to={all_routes.newdashboard} className="logo logo-normal">
              <ImageWithBasePath src="assets/img/logo.png" alt="img" />
            </Link>
            <Link to={all_routes.newdashboard} className="logo logo-white">
              <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
            </Link>
            <Link to={all_routes.newdashboard} className="logo-small">
              <ImageWithBasePath src="assets/img/logo-small.png" alt="img" />
            </Link>
            <Link
              id="toggle_btn"
              to="#"
              style={{
                display:
                  pathname.includes("tasks") || pathname.includes("pos")
                    ? "none"
                    : pathname.includes("compose")
                    ? "none"
                    : "",
              }}
              onClick={handlesidebar}
            >
              <FeatherIcon icon="chevrons-left" className="feather-16" />
            </Link>
          </div>
          {/* /Logo */}
          <Link
            id="mobile_btn"
            className="mobile_btn"
            to="#"
            onClick={sidebarOverlay}
          >
            <span className="bar-icon">
              <span />
              <span />
              <span />
            </span>
          </Link>
          {/* Header Menu */}
          <ul className="nav user-menu">
            {/* Search */}
            <li className="nav-item nav-searchinputs">
              <div className="top-nav-search">
                <Link to="#" className="responsive-search">
                  <Search />
                </Link>
                <form action="#" className="dropdown">
                  <div
                    className="searchinputs input-group dropdown-toggle"
                    id="dropdownMenuClickable"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <input type="text" placeholder="Search" />
                    <div className="search-addon">
                      <span>
                        <i className="ti ti-search" />
                      </span>
                    </div>
                    <span className="input-group-text">
                      <kbd className="d-flex align-items-center">
                        <ImageWithBasePath
                          src="assets/img/icons/command.svg"
                          alt="img"
                          className="me-1"
                        />
                        K
                      </kbd>
                    </span>
                  </div>

                  <div
                    className="dropdown-menu search-dropdown"
                    aria-labelledby="dropdownMenuClickable"
                  >
                    <div className="search-info">
                      {/* pop down ui on click of search box */}
                    </div>
                  </div>
                </form>
              </div>
            </li>
            {/* /Search */}

            {/* Select Store */}
            <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
              {user?.role === "store_manager" ? (
                // Static label for store managers
                <div className="nav-link select-store">
                  <span className="user-info">
                    <span className="user-letter mr-4">
                      <ImageWithBasePath
                        src={
                          "assets/img/store/store-01.png"
                        }
                        alt="Store Logo"
                        className="img-fluid"
                      />
                    </span>
                    <span className="user-detail">
                      <span className="user-name">
                        {selectedStore?.name || "Loading store..."}
                      </span>
                    </span>
                  </span>
                </div>
              ) : (
                // Dropdown for other roles
                <>
                  <Link
                    to="#"
                    className="dropdown-toggle nav-link select-store"
                    data-bs-toggle="dropdown"
                  >
                    <span className="user-info">
                      <span className="user-letter">
                        <ImageWithBasePath
                          src={
                            selectedStore?.logoUrl ||
                            (stores?.data && stores.data[0]?.logoUrl) ||
                            "assets/img/store/store-01.png"
                          }
                          alt="Store Logo"
                          className="img-fluid"
                        />
                      </span>
                      <span className="user-detail">
                        <span className="user-name">
                          {selectedStore?.name ||
                            (stores?.data && stores.data[0]?.name) ||
                            "Select Store"}
                        </span>
                        <small className="text-muted d-block">
                          {/* {selectedStore?.address ||
                            (stores?.data && stores.data[0]?.address) ||
                            ""} */}
                        </small>
                      </span>
                    </span>
                  </Link>
                  <div className="dropdown-menu dropdown-menu-right">
                    {loading ? (
                      <div className="dropdown-item">Loading...</div>
                    ) : error ? (
                      <div className="dropdown-item text-danger">
                        Error loading stores
                      </div>
                    ) : stores?.data?.length ? (
                      stores.data.map((store) => (
                        <Link
                          key={store._id}
                          to="#"
                          className="dropdown-item"
                          onClick={() => handleStoreSelect(store)}
                        >
                          <div className="d-flex align-items-center">
                            <ImageWithBasePath
                              src={
                                store.logoUrl || "assets/img/store/store-01.png"
                              }
                              alt={store.name}
                              className="me-2"
                              style={{
                                width: "30px",
                                height: "30px",
                                objectFit: "cover",
                              }}
                            />
                            <div>
                              <div className="fw-bold">{store.name}</div>
                              <small className="text-muted">
                                {/* {store.address} */}
                              </small>
                            </div>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <div className="dropdown-item">No stores found</div>
                    )}
                  </div>
                </>
              )}
            </li>
            {/* /Select Store */}

            <li className="nav-item dropdown link-nav">
              <Link
                to="#"
                className="btn btn-primary btn-md d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i className="ti ti-circle-plus me-1" />
                Add New
              </Link>
              <div className="dropdown-menu dropdown-xl dropdown-menu-center shadow-lg">
                <div className="row g-2">
                  <div className="col-md-4">
                    <Link to={route.appointments} className="link-item">
                      <span className="link-icon">
                        <i className="ti ti-brand-codepen" />
                      </span>
                      <p>Appointments</p>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link to={route.addservice} className="link-item">
                      <span className="link-icon">
                        <i className="ti ti-square-plus" />
                      </span>
                      <p>Services</p>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link to={route.addemployee} className="link-item">
                      <span className="link-icon">
                        <i className="ti ti-shopping-bag" />
                      </span>
                      <p>Employees</p>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link to={route.expenselist} className="link-item">
                      <span className="link-icon">
                        <i className="ti ti-shopping-cart" />
                      </span>
                      <p>Expenses</p>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link to={route.attendanceemployee} className="link-item">
                      <span className="link-icon">
                        <i className="ti ti-file-text" />
                      </span>
                      <p>Attendance</p>
                    </Link>
                  </div>
                  <div className="col-md-4">
                    <Link to={route.addsales} className="link-item">
                      <span className="link-icon">
                        <i className="ti ti-device-floppy" />
                      </span>
                      <p>Billing</p>
                    </Link>
                  </div>
                </div>
              </div>
            </li>
            <li className="nav-item pos-nav">
              <Link
                to={route.addsales}
                className="btn btn-dark btn-md d-inline-flex align-items-center"
              >
                <i className="ti ti-device-laptop me-1" />
                POS
              </Link>
            </li>

            {/* Flag */}
            <li className="nav-item dropdown has-arrow flag-nav nav-item-box">
              <Link
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                to="#"
                role="button"
              >
                {/* <i data-feather="globe" /> */}
                {/* <FeatherIcon icon="globe" /> */}
                <ImageWithBasePath src={flagImage} alt="img" height={16} />
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  to="#"
                  className="dropdown-item active"
                  onClick={() => changeLanguage("en")}
                >
                  <ImageWithBasePath
                    src="assets/img/flags/in.png"
                    alt="img"
                    height={16}
                  />
                  India
                </Link>
              </div>
            </li>
            {/* /Flag */}
            <li className="nav-item nav-item-box">
              <Link
                to="#"
                id="btnFullscreen"
                onClick={() => toggleFullscreen()}
                className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
              >
                {/* <i data-feather="maximize" /> */}
                <i className="ti ti-maximize"></i>
              </Link>
            </li>
            <li className="nav-item nav-item-box">
              <Link
                to="https://mail.google.com/mail/?authuser=0"
                target="_blank"
              >
                {/* <i data-feather="mail" /> */}
                <i className="ti ti-mail"></i>
                {/* <span className="badge rounded-pill">1</span> */}
              </Link>
            </li>
            {/* Notifications */}
            <li className="nav-item dropdown nav-item-box">
              <Link
                to="#"
                className="dropdown-toggle nav-link"
                data-bs-toggle="dropdown"
              >
                {/* <i data-feather="bell" /> */}
                <i className="ti ti-bell"></i>
                {/* <span className="badge rounded-pill">2</span> */}
              </Link>
              <div className="dropdown-menu notifications">
                <div className="topnav-dropdown-header">
                  {/* <h5 className="notification-title">Notifications</h5> */}
                  <Link to="#" className="clear-noti">
                    Mark all as read
                  </Link>
                </div>
                {/* <div className="noti-content">
                  <ul className="notification-list">
                    <li className="notification-message">
                      <Link to={route.activities}>
                        <div className="media d-flex">
                          <span className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              alt="Img"
                              src="assets/img/profiles/avatar-13.jpg"
                            />
                          </span>
                          <div className="flex-grow-1">
                            <p className="noti-details">
                              <span className="noti-title">James Kirwin</span>{" "}
                              confirmed his order. Order No: #78901.Estimated
                              delivery: 2 days
                            </p>
                            <p className="noti-time">4 mins ago</p>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li className="notification-message">
                      <Link to={route.activities}>
                        <div className="media d-flex">
                          <span className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              alt="Img"
                              src="assets/img/profiles/avatar-03.jpg"
                            />
                          </span>
                          <div className="flex-grow-1">
                            <p className="noti-details">
                              <span className="noti-title">Leo Kelly</span>{" "}
                              cancelled his order scheduled for 17 Jan 2025
                            </p>
                            <p className="noti-time">10 mins ago</p>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li className="notification-message">
                      <Link to={route.activities} className="recent-msg">
                        <div className="media d-flex">
                          <span className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              alt="Img"
                              src="assets/img/profiles/avatar-17.jpg"
                            />
                          </span>
                          <div className="flex-grow-1">
                            <p className="noti-details">
                              Payment of $50 received for Order #67890 from{" "}
                              <span className="noti-title">Antonio Engle</span>
                            </p>
                            <p className="noti-time">05 mins ago</p>
                          </div>
                        </div>
                      </Link>
                    </li>
                    <li className="notification-message">
                      <Link to={route.activities} className="recent-msg">
                        <div className="media d-flex">
                          <span className="avatar flex-shrink-0">
                            <ImageWithBasePath
                              alt="Img"
                              src="assets/img/profiles/avatar-02.jpg"
                            />
                          </span>
                          <div className="flex-grow-1">
                            <p className="noti-details">
                              <span className="noti-title">Andrea</span>{" "}
                              confirmed his order. Order No: #73401.Estimated
                              delivery: 3 days
                            </p>
                            <p className="noti-time">4 mins ago</p>
                          </div>
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div> */}
                {/* <div className="topnav-dropdown-footer d-flex align-items-center gap-3">
                  <Link to="#" className="btn btn-secondary btn-md w-100">
                    Cancel
                  </Link>
                  <Link
                    to={route.activities}
                    className="btn btn-primary btn-md w-100"
                  >
                    View all
                  </Link>
                </div> */}
              </div>
            </li>
            {/* /Notifications */}
            <li className="nav-item nav-item-box">
              <Link
                to="#"
                data-bs-toggle="offcanvas"
                data-bs-target="#theme-setting"
                role="button"
                aria-controls="theme-setting"
              >
                <i className="ti ti-settings"></i>
              </Link>
            </li>
            <li className="nav-item dropdown has-arrow main-drop profile-nav">
              <Link
                to="#"
                className="nav-link userset"
                data-bs-toggle="dropdown"
              >
                <span className="user-info p-0">
                  <span className="user-letter">{renderUserAvatar()}</span>
                </span>
              </Link>
              <div className="dropdown-menu menu-drop-user">
                <div className="profileset d-flex align-items-center">
                  <span className="user-img me-2">{renderUserAvatar()}</span>
                  <div>
                    <h6 className="fw-medium">{user?.name}</h6>
                    <p>{user?.role}</p>
                  </div>
                </div>
                <Link className="dropdown-item" to={route.profile}>
                  <i className="ti ti-user-circle me-2" />
                  MyProfile
                </Link>
                <Link className="dropdown-item" to={route.salesreport}>
                  <i className="ti ti-file-text me-2" />
                  Reports
                </Link>
                <Link className="dropdown-item" to={route.generalsettings}>
                  <i className="ti ti-settings-2 me-2" />
                  Settings
                </Link>
                <hr className="my-2" />
                <button
                  className="dropdown-item logout pb-0"
                  onClick={handleLogout}
                  style={{
                    background: "none",
                    border: "none",
                    width: "100%",
                    textAlign: "left",
                    cursor: "pointer",
                  }}
                >
                  <i className="ti ti-logout me-2" />
                  Logout
                </button>
              </div>
            </li>
          </ul>
          {/* /Header Menu */}
          {/* Mobile Menu */}
          <div className="dropdown mobile-user-menu">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link className="dropdown-item" to="profile">
                My Profile
              </Link>
              <Link className="dropdown-item" to="generalsettings">
                Settings
              </Link>
              <button
                className="dropdown-item"
                onClick={handleLogout}
                style={{
                  background: "none",
                  border: "none",
                  width: "100%",
                  textAlign: "left",
                  cursor: "pointer",
                }}
              >
                Logout
              </button>
            </div>
          </div>
          {/* /Mobile Menu */}
        </div>
      </div>
    </>
  );
};

export default Header;
